import { MdClose } from "react-icons/md";
import { useDispatch } from "react-redux";
import { ApproveRefundRequest } from "../../../Redux/Action/MasterAdminAction";

export const ApproveSureModel = ({
  setApproveReasonModel,
  userDetail,
  setRefundModal,
}) => {
  const dispatch = useDispatch();

  const handleApproveRequest = async (e) => {
    e.preventDefault();
    try {
      const data = {
        req_id: userDetail?.req_id,
        request_status: true,
      };

      dispatch(
        ApproveRefundRequest(data, setApproveReasonModel, setRefundModal)
      );
    } catch (error) {
    }
  };

  return (
    <>
      <div className="bg-black fixed  top-0 left-0 right-0 w-full h-full z-50 bg-opacity-50">
        <div className="bg-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-xl rounded-[10px] w-[500px]">
          <div className="rounded-t-2xl px-5 md:px-3 xl:px-5 py-2 xl:py-3 uppercase font-Poppins text-xl  flex justify-between items-center">
            <div className="text-[18px] xl:text-xl">Approve Request</div>
            <button
              onClick={() => {
                setApproveReasonModel(false);
              }}
            >
              <MdClose className="text-gray-500 text-2xl hover:text-black" />
            </button>
          </div>
          <hr></hr>
          {/* Body */}
          <div className="px-6 py-5">
            <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full ">
              {/* info icon */}
              <svg
                className="h-6 w-6 text-gray-500"
                viewBox="0 0 20 20"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <p
              id="confirm-modal-desc"
              className="text-center text-sm text-[#1A1A1A]"
            >
              Are you sure you want to approve this request?
            </p>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end gap-3 px-5 pb-5">
            <button
              onClick={() => setApproveReasonModel(false)}
              type="button"
              className="border border-[#FCDD00] text-[#1A1A1A] w-[100px] px-5 py-2 rounded-lg font-Poppins text-lg flex items-center justify-center gap-1 cursor-pointer hover:scale-105 outline-none"
            >
              Cancel
            </button>
            <button
              onClick={handleApproveRequest}
              type="button"
              className="bg-[#FCDD00] text-[#1A1A1A] w-[100px] px-5 py-2 rounded-lg font-Poppins text-lg flex items-center justify-center gap-1 cursor-pointer hover:scale-105 outline-none"
            >
              Approve
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
